import FounderPortrait from "@/components/about/FounderPortrait";
import FounderNarrative from "@/components/about/FounderNarrative";

const TEXTURE_URL =
  "https://static.prod-images.emergentagent.com/jobs/79144187-2235-4ee7-9fa7-a726d5fa0d55/images/ee0826617731e28633def1043fa74b7fe9c94e40a77e7980e7a75dfc35b0424f.png";

export default function AboutFounder() {
  return (
    <section className="relative py-32 md:py-40 bg-nightsky text-ivory overflow-hidden">
      <div
        className="absolute inset-0 opacity-25 mix-blend-soft-light pointer-events-none"
        style={{ backgroundImage: `url('${TEXTURE_URL}')`, backgroundSize: "cover" }}
      />
      <div className="relative max-w-[1480px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-10 md:gap-16">
        <FounderPortrait />
        <FounderNarrative />
      </div>
    </section>
  );
}
